import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';

import * as encoding from 'encoding-japanese';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';

import { AccountBookService } from '../../../service/account-book/account-book.service';
import { PdfReportService } from '../../../service/pdf-report/pdf-report.service';
import { CsvReportService } from '../../../service/csv-report/csv-report.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { insertcomma } from '../../../util/util';
import { isAuthority } from '../../../util/util';
import { GridDoubleButtonRendererComponent } from '../../../render/grid-double-button-renderer.component';
import { AgGridHelper } from '../../../util/AgGridHelper';

@Component({
  selector: 'app-root',
  templateUrl: 'wa8005.component.html',
  styleUrls: ['wa8005.component.scss']
})
export class Wa8005Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA8005:請求照会';

  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData = [];

  public config = config;

  public ownerId: number;
  public ownerResult: any;

  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  // for print
  public reporttrnId: number;
  private reportOpened = false;
  private reportTry = 0;
  public url = '#';

  public viewModes: any[];
  public viewMode = 0;

  // Authorith
  public disableF2 = isAuthority('wa8005', 'F2');
  public disableF3 = isAuthority('wa8005', 'F3');
  public disableF4 = isAuthority('wa8005', 'F4');
  public disableF5 = isAuthority('wa8005', 'F5');
  public disableF6 = isAuthority('wa8005', 'F6');

  private errorInfo = '';

  @ViewChild('gridView')
  private gridView: ElementRef;
  private gridHelper: AgGridHelper;

  private isEnableClearFilter = null;
  private paginationGetRowCount = 0;
  private paginationGetTotalPages = 0;
  private paginationGetCurrentPage = 0;
  private paginationGoToFirstPage;
  private paginationGoToNextPage;
  private selectedCount = 0;

  public rowsPerPageModel = [{ value: 10, viewValue: '10' }, { value: 20, viewValue: '20' }, { value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }];
  public rowsPerPage = config.rowsPerPageSize;

  private tabIndex = 0;
  private originalRowData: any[];

  private isShowModal1 = false;
  private isShowModal2 = false;
  private nodeForOverlay = null;

  private isConfirmButton1Enable = false;
  private isConfirmButton2Enable = false;
  private isConfirmButton3Enable = false;
  private isConfirmRequestFeeButtonEnabled = false;

  private isOwnerSearchNone = false;

  constructor(
    private router: Router,
    private accountBookService: AccountBookService,
    private pdfReportService: PdfReportService,
    private csvReportService: CsvReportService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    this.gridHelper = new AgGridHelper();
    this.gridHelper.scrollArrowCustomVarietyValue = -121;
    this.gridOptions = <GridOptions>{
      rowSelection: 'multiple',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      pagination: true,
      paginationPageSize: this.rowData.length,
      suppressRowClickSelection: true,
      shohwLoadingOverlay: true,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        this.toggleGridCheckbox();
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa8005_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.onGridReady();
      },
      onFilterChanged: () => {
        this.errorInfo = '';
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
      },
      onPaginationChanged: () => {
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.paginationGetTotalPages = this.gridOptions.api.paginationGetTotalPages();
        this.paginationGetCurrentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
      },
      onRowDataChanged: () => {
        this.errorInfo = '';
        this.gridHelper.onRowDataChanged();

        this.selectedCount = 0;
        /*
        Observable.timer(100).subscribe(() => {
          this.searchByKey();
        });*/
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper.fixedAgMenu();
      },
      onSortChanged: () => {
        this.errorInfo = '';
        this.gridHelper.renderGridCheckboxImage();
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.selectedCount = this.gridOptions.api.getSelectedRows().length;

        if (this.selectedCount == 0) {
          this.isConfirmButton1Enable = false;
          this.isConfirmButton2Enable = false;
          this.isConfirmButton3Enable = false;
          this.isConfirmRequestFeeButtonEnabled = false;
          return;
        }

        var isConfirmButton1Enable = null;
        var isConfirmButton2Enable = null;
        var isConfirmButton3Enable = null;

        this.gridOptions.api.getSelectedNodes().forEach(node => {
          var data = node.data;
          isConfirmButton1Enable = isConfirmButton1Enable == null || isConfirmButton1Enable == true ? data['staccountbookstockhandleTx'] !== '承認' : isConfirmButton1Enable;
          isConfirmButton2Enable = data['staccountbookexpenseTx'] !== '承認';
          isConfirmButton3Enable = isConfirmButton3Enable == null || isConfirmButton3Enable == true ? data['staccountbookdeliTx'] !== '承認' : isConfirmButton3Enable;
        });
        this.isConfirmButton1Enable = isConfirmButton1Enable;
        this.isConfirmButton2Enable = isConfirmButton2Enable;
        this.isConfirmButton3Enable = isConfirmButton3Enable;

        this.isConfirmRequestFeeButtonEnabled = !this.isConfirmButton1Enable && !this.isConfirmButton2Enable && !this.isConfirmButton3Enable;
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        field: 'checkbox',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        width: 30,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        pinned: 'left',
        cellClass: ['tc', 'cl_w', 'noCellFocus']
      },
      {
        headerName: '',
        filter: 'text',
        unSortIcon: false,
        suppressMenu: true,
        width: 180,
        cellClass: ['tl', 'cellclass'],
        pinned: 'left',
        cellRendererFramework: GridDoubleButtonRendererComponent,
        cellRendererParams: {
          leftButton: {
            text: '明細書',
            onClick: this.onGridLeftButtonClick.bind(this)
          },
          rightButton: {
            text: '請求書',
            onClick: this.onGridRightButtonClick.bind(this)
          }
        }
      },
      {
        headerName: '保',
        field: 'col101',
        filter: 'text',
        unSortIcon: false,
        suppressMenu: true,
        width: 40,
        cellClass: ['tc', 'cellclass'],
        pinned: 'left',
        cellRenderer: params => {
          var img = '';
          if (params.data.staccountbookstockhandleTx == '承認') {
            img = "<img src='../../../../assets/images/check.png'>";
          }
          const element = document.createElement('div');
          element.innerHTML = "<div class='chkGrid'>" + img + '</div>';

          return element;
        }
      },
      {
        headerName: '諸',
        field: 'col102',
        filter: 'text',
        unSortIcon: false,
        suppressMenu: true,
        width: 40,
        cellClass: ['tc', 'cellclass'],
        pinned: 'left',
        cellRenderer: params => {
          var img = '';
          if (params.data.staccountbookexpenseTx == '承認') {
            img = "<img src='../../../../assets/images/check.png'>";
          }
          const element = document.createElement('div');
          element.innerHTML = "<div class='chkGrid'>" + img + '</div>';

          return element;
        }
      },
      {
        headerName: '運',
        field: 'col103',
        filter: 'text',
        unSortIcon: false,
        suppressMenu: true,
        width: 40,
        cellClass: ['tc', 'cellclass'],
        pinned: 'left',
        cellRenderer: params => {
          var img = '';
          if (params.data.staccountbookdeliTx == '承認') {
            img = "<img src='../../../../assets/images/check.png'>";
          }
          const element = document.createElement('div');
          element.innerHTML = "<div class='chkGrid'>" + img + '</div>';

          return element;
        }
      },
      {
        headerName: '締日',
        field: 'bookendDt',
        sort: 'desc',
        width: this.getColumnWidth('bookendDt', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '計上年月',
        field: 'bookyearmonthTx',
        width: this.getColumnWidth('bookyearmonthTx', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        width: this.getColumnWidth('ownerCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '小計',
        field: 'totalpricenetNr',
        width: this.getColumnWidth('totalpricenetNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '課税金額',
        field: 'totaltaxbaseNr',
        width: this.getColumnWidth('totaltaxbaseNr', 100),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '消費税',
        field: 'totaltaxNr',
        width: this.getColumnWidth('totaltaxNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '請求金額',
        field: 'totalpriceNr',
        width: this.getColumnWidth('totalpriceNr', 120),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '請求ｽﾃｰﾀｽ',
        field: 'staccountbookTx',
        width: this.getColumnWidth('staccountbookTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '集計日時',
        field: 'createDt',
        width: this.getColumnWidth('createDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '確定日時',
        field: 'endDt',
        width: this.getColumnWidth('endDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '確定者名',
        field: 'enduserTx',
        width: this.getColumnWidth('enduserTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '保管荷役料',
        field: 'stockhandlepriceNr',
        width: this.getColumnWidth('stockhandlepriceNr', 120),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '保管荷役料ｽﾃｰﾀｽ',
        field: 'staccountbookstockhandleTx',
        width: this.getColumnWidth('staccountbookstockhandleTx', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '保管荷役料承認日時',
        field: 'confirmstockhandleDt',
        width: this.getColumnWidth('confirmstockhandleDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      /*
      {
        headerName: '保管荷役料承認者名',
        field: 'confirmstockhandleuserTx',
        width: this.getColumnWidth('confirmstockhandleuserTx', 200)
      },
      */
      {
        headerName: '諸掛費',
        field: 'expensepriceNr',
        width: this.getColumnWidth('expensepriceNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '諸掛ｽﾃｰﾀｽ',
        field: 'staccountbookexpenseTx',
        width: this.getColumnWidth('staccountbookexpenseTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '諸掛承認日時',
        field: 'confirmexpenseDt',
        width: this.getColumnWidth('confirmexpenseDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '諸掛承認者名',
        field: 'confirmexpenseuserTx',
        width: this.getColumnWidth('confirmexpenseuserTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '運送費',
        field: 'delipriceNr',
        width: this.getColumnWidth('delipriceNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '運送費ｽﾃｰﾀｽ',
        field: 'staccountbookdeliTx',
        width: this.getColumnWidth('staccountbookdeliTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '運送費承認日時',
        field: 'confirmdeliDt',
        width: this.getColumnWidth('confirmdeliDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '運送費承認者名',
        field: 'confirmdeliuserTx',
        width: this.getColumnWidth('confirmdeliuserTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新日時',
        field: 'updDt',
        width: this.getColumnWidth('updDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新者名',
        field: 'upduserTx',
        width: this.getColumnWidth('upduserTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録日時',
        field: 'addDt',
        width: this.getColumnWidth('addDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録者名',
        field: 'adduserTx',
        width: this.getColumnWidth('adduserTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      }
    ];
    this.gridHelper.setGridOptions(this.gridOptions);
    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerId = selectedOwner.ownerId;
    }
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonTripleMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }

    this.viewModes = [{ id: 0, text: '全表示' }, { id: 1, text: '未承認のみ' }];

    this.viewMode = 0;
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa8005_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa8005_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa8005_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
    document.getElementsByTagName('body')[0].style.minWidth = '1280px';
    setTimeout(() => {
      this.onSubmit();
    }, 500);
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonTripleMargin;
  }

  onSubmit(event?) {
    this.errorInfo = '';
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.gridOptions.api.showLoadingOverlay();
    let eventObj: object = { event: this.viewMode };
    this.accountBookService
      .get(eventObj, this.ownerId)
      .then(outputJson => {
        console.log(outputJson);
        //this.rowData = outputJson.accountbooks;
        this.originalRowData = outputJson.accountbooks;
        this.filterGrid();
        setTimeout(() => {
          this.gridOptions.api.hideOverlay();
          this.working = false;
        },300);
      })
      .catch(error => {
        this.working = false;
        this.gridOptions.api.hideOverlay();
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  executeReport() {
    this.errorInfo = '';
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.errorInfo = '対象を選択して下さい';
      this.working = false;
      return;
    }
    this.working = true;
    const selectItems: object[] = [];
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      const jsonUnit: object = {
        selectId: this.gridOptions.api.getSelectedNodes()[i].data['accountbookId']
      };
      selectItems.push(jsonUnit);
    }
    this.accountBookService
      .execute({
        updprogramCd: 'wa8005',
        details: selectItems
      })
      .then(outputJson => {
        this.working = false;
        sessionStorage.setItem('SuccessInfoMessage', '請求データから請求金額を再作成しました。');
        // this.selectOffAction();
        this.onSubmit();
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  confirmReport(reportCd: string) {
    this.errorInfo = '';
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.errorInfo = '対象を選択して下さい';
      return;
    }

    if (reportCd === 'RA8002') {
      var isConfirmButton2Enable = null;
      this.gridOptions.api.getSelectedNodes().forEach(node => {
        var data = node.data;
        isConfirmButton2Enable = isConfirmButton2Enable == null || isConfirmButton2Enable == true ? data['staccountbookexpenseTx'] !== '承認' : isConfirmButton2Enable;
      });
      if (!isConfirmButton2Enable) {
        this.errorInfo = '既に確定されている明細が１件以上あります';
        return;
      }
    }
    this.working = true;
    const selectItems: object[] = [];
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      var data = this.gridOptions.api.getSelectedNodes()[i].data;

      if (data['staccountbookId'] == 9) {
        this.errorInfo = '既に確定されている明細が1件以上あります';
        this.working = false;
        this.onSubmit();
        return;
      }
      const jsonUnit: object = {
        selectCd: reportCd,
        selectId: data['accountbookId'],
        parameter1Tx: data['createDt']
      };
      selectItems.push(jsonUnit);
    }
    this.accountBookService
      .confirm({
        updprogramCd: 'wa8005',
        details: selectItems
      })
      .then(outputJson => {
        this.working = false;
        this.onSubmit();
        switch (reportCd) {
          case 'RA8001':
            sessionStorage.setItem('SuccessInfoMessage', '保管荷役料を承認しました');
            break;
          case 'RA8002':
            sessionStorage.setItem('SuccessInfoMessage', '諸掛を承認しました');
            break;
          case 'RA8003':
            sessionStorage.setItem('SuccessInfoMessage', '運送費を承認しました');
            break;
        }
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  commitReport() {
    this.errorInfo = '';
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.errorInfo = '対象を選択して下さい';
      this.working = false;
      return;
    }
    this.working = true;
    const selectItems: object[] = [];
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      var data = this.gridOptions.api.getSelectedNodes()[i].data;
      if (data['staccountbookId'] == 9) {
        sessionStorage.setItem('SuccessInfoMessage', '既に確定されている明細が1件以上あります');
        this.working = false;
        this.onSubmit();
        return;
      }
      const jsonUnit: object = {
        selectId: data['accountbookId'],
        parameter1Tx: data['createDt']
      };
      selectItems.push(jsonUnit);
    }
    this.accountBookService
      .commit({
        updprogramCd: 'wa8005',
        details: selectItems
      })
      .then(outputJson => {
        this.working = false;
        this.onSubmit();
        sessionStorage.setItem('SuccessInfoMessage', '請求金額を確定しました');
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  printReportCsv(reportCd: string) {
      this.errorInfo = '';
    if (this.nodeForOverlay == null) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      this.working = false;
      return;
    }
    this.working = true;
    
   this.csvReportService
     .postSpring(reportCd, this.nodeForOverlay.data['ownerId'], this.nodeForOverlay.data['bookyearmonthTx'],'','','wa8005')
     .then(resultCsv => {
       this.working = true;
      
       const blob = new Blob(this.commonService.toSJis(resultCsv.fileContents), {type: 'text/csv'});
      
       // Internet Explorer
       if (window.navigator.msSaveOrOpenBlob) {
         window.navigator.msSaveOrOpenBlob(blob, resultCsv.fileName);
       } else {
         // Chrome
         const downloadLink = document.createElement('a');
         downloadLink.href = window.URL.createObjectURL(blob);
         downloadLink.download = resultCsv.fileName;
         document.body.appendChild(downloadLink);
         downloadLink.click();
         document.body.removeChild(downloadLink);
       }
       
       this.working = false;
       this.closeOvelay();
     })
     .catch(error => {
       this.working = false;
       console.log(this.commonService.getErrorMessage(error));
       this.errorInfo = this.commonService.getErrorMessage(error);
       
       this.closeOvelay();
     });
  }

  printReport(reportCd: string) {
    this.errorInfo = '';
    if (this.nodeForOverlay == null) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      this.working = false;
      return;
    }
    // Change the flag of working to true in order to disable the submit button
    this.working = true;
    // Reset the flag to indicate that the report has not been opened yet
    this.reportOpened = false;
    // Reset the limit counter
    this.reportTry = 0;
    // Submit the request to generate the report
    let excelFl = 0;
    let isCodeFl = 0;
    this.pdfReportService
      .post(this.nodeForOverlay.data['ownerId'], this.nodeForOverlay.data['bookyearmonthTx'], reportCd, excelFl, 'wa8005')
      .then(outputJson => {
        this.reporttrnId = outputJson.reporttrnId;
        this.working = true;
		// Call the PDF report service
        this.pdfReportService
          .printReport(reportCd, this.reporttrnId)
          .then(outputJson => {
              // Change the working flag to false in order to enable the submit button
              this.working = false;
              const filename = outputJson.pdfFilename
              const url = environment.pdfPath + filename;
              this.openReport(url);
          })
          .catch(error => {
            // Change the working flag to false in order to enable the submit button
            this.working = false;
            console.log(this.commonService.getErrorMessage(error));
            this.errorInfo = this.commonService.getErrorMessage(error);
          });
        this.closeOvelay();
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);

        this.closeOvelay();
      });
  }

  waitResult() {
    const obs = Observable.interval(1000).subscribe(() => {
      // Verify that we have not tried more than 10 times
      if (this.reportTry <= 10) {
        // Add a new try to the counter
        this.reportTry++;
        // Call the PDF report service
        this.pdfReportService
          .get(this.reporttrnId)
          .then(outputJson => {
            // seems we can get the report path correctly
            // If the createdFl is 0 the report has not finished so we retry again.
            // If the createdFl is 1 we get the report name and open a new window to show the PDF file.
            if (outputJson.reports[0].createdFl === 1) {
              // Cancel the Observable when success
              obs.unsubscribe();
              // Change the working flag to false in order to enable the submit button
              this.working = false;
              const url = environment.bucketUrl + '/report/' + outputJson.reports[0].reportpathTx;
              // We open a new tab to display the PDF.
              // If preferred we could get the PDF data and send the blob to the new tab instead.
              this.openReport(url);
            }
            if (outputJson.reports[0].createdFl === -1) {
              // Cancel the Observable when success
              obs.unsubscribe();
              this.working = false;
              this.errorInfo = '対象データがないため帳票が作成できませんでした。';
            }
          })
          .catch(error => {
            // Cancel the Observable in case of error
            obs.unsubscribe();
            // Change the working flag to false in order to enable the submit button
            this.working = false;
            console.log(this.commonService.getErrorMessage(error));
            this.errorInfo = this.commonService.getErrorMessage(error);
          });
      } else {
        // Cancel the Observable if the number of tries maxed out
        obs.unsubscribe();
        // Change the working flag to false in order to enable the submit button
        this.working = false;
        this.errorInfo = '帳票を取得できませんでした（タイムアウト）。再発する場合は管理者へ連絡してください。';
      }
    });
  }

  // Open the newly generated report on a different tab/window
  openReport(url) {
    // Verify that the report has not been opened already in cases where the network response is slow
    // and we get multiple responses at the same time.
    if (this.reportOpened === false) {
      this.url = url;
      const popup_window = window.open(url);
      try {
        popup_window.focus();
      } catch (e) {
        (this.errorInfo = 'ポップアップが許可されていません。PDFを開いて良い場合は、「PDFを開く」ボタンを押してください。'), url, 'PDFを開く';
      }
      // Change the flag to indicate that the report was already opened
      this.reportOpened = true;
    }
  }

  changeViewMode(event) {
    this.onSubmit(event);
  }
  onFilterClear() {
    this.errorInfo = '';
    this.gridOptions.api.setFilterModel(null);
  }

  changeOwner(selectedOwnerId) {
    console.log(selectedOwnerId);
    if (selectedOwnerId !== null) {
      if (selectedOwnerId !== undefined) {
        this.ownerId = selectedOwnerId;
      } else {
        this.ownerId = undefined;
      }
      this.onSubmit();
    } else {
      this.rowData = [];
      this.originalRowData = [];
      this.gridOptions.api.deselectAll();
      this.filterGrid();
    }
  }

  paginatorRowChange() {
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
  }

  onGridLeftButtonClick(node) {
    this.errorInfo = '';
    this.nodeForOverlay = node;
    this.isShowModal1 = true;
  }

  onGridRightButtonClick(node) {
    this.errorInfo = '';
    this.nodeForOverlay = node;
    this.isShowModal2 = true;
  }

  onTabChanged(index) {
    this.tabIndex = index;
    this.errorInfo = '';
    this.selectedCount = 0;
    this.filterGrid();
    this.toggleGridCheckbox();
    this.gridOptions.api.deselectAll();
    if (index === 0) this.gridOptions.api.paginationSetPageSize(this.rowData.length);
    else if (index === 1) this.gridOptions.api.paginationSetPageSize(this.rowData.length);
    else this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
  }

  filterGrid() {
    var filterKeys = [];
    switch (this.tabIndex) {
      case 0:
        filterKeys.push('未承認');
        break;
      case 2:
        filterKeys.push('確定');
        break;
      case 3:
        break;
    }
    var bkgFilter = this.gridOptions.api.getFilterModel();
    this.gridOptions.api.setRowData([]);
    this.gridOptions.api.setFilterModel(bkgFilter);

    if (this.originalRowData == null || this.originalRowData.length == 0) return;

    var newRowDatas = [];
    this.originalRowData.forEach(data => {
      if (this.tabIndex == 0) {
        if (data.staccountbookstockhandleTx === '未承認' && data.staccountbookexpenseTx === '未承認' && data.staccountbookdeliTx === '未承認') {
          newRowDatas.push(data);
        }
      } else if (this.tabIndex == 1) {
        if (data.staccountbookTx != "確定") {
          if (data.staccountbookstockhandleTx === '承認' || data.staccountbookexpenseTx === '承認' || data.staccountbookdeliTx === '承認') {
            newRowDatas.push(data);
          }
        }
      } else {
        if (filterKeys.length == 0 || filterKeys.indexOf(data.staccountbookTx) != -1) {
          newRowDatas.push(data);
        }
      }
    });

    this.gridOptions.api.updateRowData({
      add: newRowDatas
    });
  }

  toggleGridCheckbox() {
    // this.gridOptions.columnApi.resetColumnState();
    this.gridOptions.columnApi.setColumnVisible('checkbox', this.tabIndex < 2);
    this.gridOptions.columnApi.setColumnVisible('col101', this.tabIndex == 1);
    this.gridOptions.columnApi.setColumnVisible('col102', this.tabIndex == 1);
    this.gridOptions.columnApi.setColumnVisible('col103', this.tabIndex == 1);
  }

  closeOvelay() {
    this.nodeForOverlay = null;
    this.isShowModal1 = false;
    this.isShowModal2 = false;
  }

  selectOffAction() {
    var leftRows = this.gridView.nativeElement.querySelectorAll('.ag-pinned-left-cols-container .ag-row');
    this._selectOffAction(leftRows);

    var containerRows = this.gridView.nativeElement.querySelectorAll('.ag-body-container .ag-row');
    this._selectOffAction(containerRows);
  }

  _selectOffAction(arr) {
    var i = 0;
    arr.forEach(element => {
      var index = element.getAttribute('row');
      var node = this.gridOptions.api.getDisplayedRowAtIndex(i);

      if (node.isSelected()) {
        node.setSelected(false);
        element.classList.add('row-update');

        setTimeout(() => {
          element.classList.add('row-default');
          element.classList.remove('row-update');
        }, 2000);
      }
      i++;
    });
  }

  ownerInputChanged(ownerId: string) {
    this.gridHelper.isOwnerNotFound = ownerId == null && ownerId !== undefined;
    this.changeOwner(ownerId);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa8Billing/wa8005/wa8005.component.ts